import { DELETE_USERS_IN_LIST_ENDPOINT } from 'api/ListsApi';
import { UseRestMutationOptions, useRestMutation } from 'utils/hooks/api';
import { useToastNotification } from 'utils/hooks/useToastNotification';
import { ApiMethod, ApiError } from 'services/api';
import { useTranslation } from './useTranslation';
import { useModalsContext } from '../contexts/modals';
import { DeleteUsersInListParams } from '../types';

export const useDeleteUsersInListMutation = (options?: UseRestMutationOptions) => {
  const { t } = useTranslation();
  const { hideModal: closeModal } = useModalsContext();
  const { mutate, ...restMutation } = useRestMutation(
    DELETE_USERS_IN_LIST_ENDPOINT,
    ApiMethod.post,
    options,
  );
  const { isLoading, isSuccess, isError, error } = restMutation;

  const deleteUsers = (params: DeleteUsersInListParams) => mutate(params);
  useToastNotification({
    enabled: !isLoading && isSuccess,
    onDone: closeModal,
    positive: isSuccess,
    positiveMessage: t('toast.deleteUsers.positive'),
  });
  useToastNotification({
    enabled: !isLoading && isError,
    negative: isError,
    negativeMessage:
      (error as ApiError)?.response?.data?.message || t('toast.deleteUsers.negative'),
  });
  return { deleteUsers, ...restMutation };
};
